export default __webpack_public_path__ + "static/runner_scaled-4550b3600fd240899953792a87d12afe.gif";